<template>
<div>
    <ValidationObserver ref="observer" v-slot="{ passes }">
        <div class="nj-card">
            <h1 class="subtitle">Ordenes de Compra o Servicio</h1>
            <hr />
            <orden-header :orden="orden" @seleccionarPedido="seleccionarPedido($event)"></orden-header>
            <br>
            <orden-detail :orden="orden" :passes="passes" ref="OrdenDetail"></orden-detail>
        </div>
    </ValidationObserver>
</div>
</template>
<script>
import { ValidationObserver } from "vee-validate"
import OrdenHeader from "./OrdenHeader"
import OrdenDetail from "./OrdenDetail"

export default {
    name: "OrdenNew",
    components: {
        OrdenDetail,
        OrdenHeader,
        ValidationObserver
    },
    data() {
        return {
            orden: {
                orden_items: [],
                orden_impuestos: [
                    {
                        id_orden_impuesto: null,
                        descripcion: "IGV",
                        valor: 0.18,
                        valor_aplicado: 0,
                        ori_tipo: 1
                    },
                    {
                        id_orden_impuesto: null,
                        descripcion: "Percepción",
                        valor: 0,
                        valor_aplicado: 0,
                        ori_tipo: 3
                    }
                ],
                descuento: 0,
                tipo_descuento: 1,
                tipo_orden: 1,
                lugar_entrega: "AV. MANUEL OLGUÍN 211, SANTIAGO DE SURCO",
                monto_con_impuesto: 0,
                monto_son_impuesto: 0,
                es_importacion: false,
                centro_costo: {
                    id_centro_costo: null
                },
                proveedor: {
                    id_proveedor: null
                },
                metodo_pago: {
                    id_metodo: null
                },
                tipo_documento: {
                    id_tipo_documento: null
                },
                fecha_pago: null,
                carta_credito: "",
                condicion_comercial: { id_condicion: null },
                gerencia: { id_usuario: null },
                administrador: { id_usuario: null },
                contabilidad: { id_usuario: null },
                pais: { id_pais: null },
                moneda: { id_moneda: null },
                referencia: "",
                referencia_detalle: "",
                observacion: "",
                is_new: true,
                ord_porcentaje_adelanto: null,
            },
        }
    },
    methods: {
        seleccionarPedido(pedido) {
            if (pedido != undefined && pedido != null) {
                this.$refs.OrdenDetail.cargarItemsDePedido(pedido.pei_id)
            }
        }
    },
}
</script>

<style scoped></style>
